import script from "./SettingsDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsDialog.vue?vue&type=style&index=0&id=dfefebe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfefebe4"]])

export default __exports__